<template>
    <div class="main_center">
        <div class="content">
            <searchBox
                    :dialogVisible.sync="moreSearchItem"
                    @dialogCancle="dialogCancle"
                    title="更多筛选">
                <div class="search-drawer">
                    <el-form :model="form" label-position="top" ref="form">
                        <el-form-item label="项目名称/编号：">
                            <el-input clearable placeholder="请输入内容搜索" v-model="form.keywords"></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="search-drawer__footer">
                        <el-button @click="searchBtn" size="small" type="primary">查询</el-button>
                        <el-button @click="refresh" plain size="small">重置</el-button>
                    </div>
                </div>
            </searchBox>
            <div class="search-content">
                <div class="pageTitle" style="margin-top:-9px;">项目备案监管</div>
                <div class="centerSearch">
                    <el-input @keyup.enter.native="searchBtn"
                              clearable placeholder="请输入项目名称/项目编号/招标人名称"
                              style="width: 500px;"
                              v-model="form.keywords">
                    </el-input>
                    <el-button @click="searchBtn" class="rightSearchBtn" size="small" type="primary">搜索</el-button>
                    <!--                <el-button @click="moreSearchItem = true" class="height_four" icon="el-icon-arrow-down" size="mini" type="text">更多搜索</el-button>-->
                    <el-divider direction="vertical"></el-divider>
                    <el-button @click="refresh" icon="el-icon-refresh" type="text"></el-button>
                </div>
            </div>
        </div>
        <div class="tableContent_" style="padding-top: 8px;">
            <el-table class="table-content"
                      :data="tableData"
                      @sort-change="sortChange"
                      @filter-change="filterChange"
                      :header-cell-style="this.$globalGrayTableHeaderStyle"
                      v-loading="dataListLoading" ref="multipleTable"
                      :height="tableMaxHeight" stripe border
                      @selection-change="handleSelectionChange"
                      row-key="id"
            >
                <el-table-column fixed label="序号" type="index" :index="indexMethod" width="50" align="center"
                                 :show-overflow-tooltip='true'></el-table-column>
                <el-table-column label="操作" fixed="right" align="center" width="100">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="router(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="标段编号" prop='bidSectionCode' align="left" min-width='160'
                                 :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column label="标段名称" prop='bidSectionName' align="left" min-width='200'
                                 :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column label="所属招标项目" prop='tenderProjectName' header-align="center" align="center" min-width='86'
                                 :show-overflow-tooltip='true'></el-table-column>
                <el-table-column label="招标人" prop='tendererName' align="left" min-width='100'
                                 :show-overflow-tooltip='true'></el-table-column>
                <el-table-column label="进场时间" prop='entryTime'
                                 header-align="center"
                                 align="center"
                                 :sortable="true"
                                 min-width='150'
                                 :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column label="已落实数量" prop='implementCount' align="left" width='100'
                                 :show-overflow-tooltip='true'></el-table-column>
                <el-table-column label="未落实数量" prop='noImplementCount' align="left" width='100'
                                 :show-overflow-tooltip='true'></el-table-column>
            </el-table>
            <el-pagination background
                           layout="total, sizes, prev, pager, next"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="pageSize"
                           :total="total"
                           :current-page="pageIndex"
                           @size-change="sizeChangeHandle"
                           @current-change="currentChangeHandle"
                           style="padding-bottom:12px;"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
import {mapState} from "vuex";
export default {
    name: "mainResponsibility",
    components: {},
    data() {
        return {
            tableMaxHeight: document.documentElement.clientHeight - 227,
            dataListLoading: false,
            yearsList: [],
            businessTypeNamelist: [],
            form: {
                businessType: 'GC',
                keywords: '',
                tradeId: '',
                year: new Date().getFullYear(),
                businessCode: "",
                businessName: "",
                witnessMod: "-1",
                witnessStatus: "-1",
                importantPrj: -1,
                datasetCode: "-1",
                flowName: '',
                superviseDeptCodeList: [],//数据所属部门
            },
            sortParams: {
                order: '',
                prop: ''
            },
            businessType: '',
            groupMark: '',
            moreSearchItem: false,
            checkList1: '',
            pageSize: 10,//每页条数
            pageIndex: 1,//当前页
            total: 0,//总条数
            tableData: [],
            multipleSelection: [],
            user: '', //角色类型
            formData: {},
            datasetCode: '',
        }
    },
    props: {},
    filters: {
        ellipsis(text, num) {
            if (text.length > num) {
                return text.substring(0, num) + '...';
            } else {
                return text;
            }
        },

    },
    activated() {
        this.form.businessType = this.$route.params.type ? this.$route.params.type : "GC";
        this.getDataList()
    },
    watch: {},
    created() {

    },
    computed: {
        ...mapState({
            isAdmin: state => {
                return state.user.userinfo.selectRoleCode == "ADMIN"
            }
        }),
    },
    mounted() {

        const that = this;
        let resizeTag = true;
        window.onresize = () => {
            if (resizeTag) { //防抖动
                that.ifmove();
                resizeTag = false
                setTimeout(() => {
                    resizeTag = true
                }, 1000)
            }
        }
        that.ifmove();
    },
    methods: {
        filterChange(filters) {
            let filtersParams = {};
            for (var i in filters) {
                var filtersArr = filters[i];
                let key = "",
                    value = [];
                filtersArr.length > 0 &&
                filtersArr.forEach(item => {
                    key = item.split("_")[0];
                    value.push(item.split("_")[1]);
                });
                key && value.length > 0
                    ? (filtersParams[key] = value.toString())
                    : null;
            }
            if (filtersParams['datasetCode']) {
                this.datasetCode = '' + filtersParams['datasetCode']
            }
            this.getDataList();
        },
        dialogCancle() {
            this.moreSearchItem = false
        },
        sortChange(column, prop, order) {
            this.sortParams.prop = prop || column.prop;
            this.sortParams.order = order || column.order;
            this.getDataList();
        },
        formatterStatusClass(historyId) {
            switch (historyId) {
                case 2:
                    return 'icon-point icon-point-success';
                    break;
                case 1:
                    return 'icon-point icon-point-verificationing';
                    break;
                case 3:
                    return 'icon-point icon-point-info';
                    break;
                case 4:
                    return 'icon-point icon-point-verificationing';
                    break;
                default:
                    return '';
                    break;
            }
        },
        ifmove() {
            let tableMaxHeight = document.documentElement.clientHeight - 277;
            this.pageSize = parseInt((tableMaxHeight) / 50) || 1;
            this.$nextTick(() => {
                this.tableMaxHeight = tableMaxHeight
            })
            // this.getDataList()

        },

        getDataList() { // 获取列表数据
            this.dataListLoading = true;
            this.$httpReq.post('/responsibility/principalResponsibility/listPage', {
                'page': this.pageIndex,
                'rows': this.pageSize,
                'searchKey': this.form.keywords,
                'orderBy': (this.sortParams.prop && this.sortParams.order) ? (this.sortParams.prop + (this.sortParams.order == "ascending" ? ' asc' : ' desc')) : "",
                'filter': {
                    "busType": this.form.businessType
                }
            }).then(res => {
                this.tableData = res.data.rows;
                this.total = res.data.total;
                this.$refs.multipleTable.doLayout();
                this.dataListLoading = false;
            })
        },
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1
            this.getDataList()
        },
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()

        },

        indexMethod(index) {
            return (this.pageIndex - 1) * this.pageSize + index + 1
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        //搜索按钮
        searchBtn() {
            this.pageIndex = 1;
            this.moreSearchItem = false;
            this.getDataList();
        },
        refresh() {//刷新按钮
            this.pageIndex = 1;
            this.moreSearchItem = false;
            this.getDataList()
        },
        router(item) { // 跳转详情
            var id = item.id;
            removeTabHandle('mainResponsibilitydetail');
            this.$router.push({
                name: 'mainResponsibilitydetail',
                query: {
                    bidSectionCode :item.bidSectionCode,
                    businessType: item.businessType || this.form.businessType,
                }
            })
        },
    },
    destroyed() {
        window.onresize = null;
    },
}
</script>
<style lang="scss">
    .content {
        .centerSearch {
            .el-input .el-input__inner, .el-input--medium .el-input__inner, .el-input--suffix .el-input__inner {
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
            }

            .rightSearchBtn {
                height: 40px;
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
            }

            .height_four {
                height: 40px;
            }

            .el-input--medium .el-input__inner {
                height: 40px;
                line-height: 40px;
            }
        }
    }
</style>
<style lang="scss" scoped>
    .mainBtn {
        padding: 16px;
    }
    .content {
        .centerSearch {
            width: calc(100% - 162px);
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            align-self: center;
        }
        .search-content {
            padding: 24px;
            display: flex;
            align-items: center;
            .pageTitle {
                font-size: 18px;
                font-weight: 600;
                color: #000000;
                height: 40px;
            }
        }
        .search-content > div {
            line-height: normal;
            padding: 0;
        }

    }

</style>
